import { Session } from "@app/shared/types";
import { scrollToElement } from "components/scrollToElement";
import { useQueryParams } from "hooks/useQueryParams";
import { useLayoutEffect } from "react";

export const useScrollToEvent = (events: Session[] | undefined) => {
    const query = useQueryParams();

    useLayoutEffect(() => {
        if (query.communityEventId) {
            const element = document.getElementById(query.communityEventId as string);
            if (element) {
                scrollToElement(element, { offset: 10 });
            }
        }
    }, [query.communityEventId, events]);
};
